const KlaviyoIcon = () => (
  <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_86_19265)">
      <g clipPath="url(#clip1_86_19265)">
        <path d="M28 24.5714H4V8.5H28L22.9735 16.5357L28 24.5714Z" fill="black" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_86_19265">
        <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
      </clipPath>
      <clipPath id="clip1_86_19265">
        <rect width="24" height="16.0714" fill="white" transform="translate(4 8.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default KlaviyoIcon;
